module.exports = __webpack_public_path__ + "img/499.60a838b5.png";